import { Advancement } from "../../../model/Dto/Advancement";
import { ApiRequest, RequestMethod } from "../../request";

const URL = "/api/dict/advancement";

export async function getAllAdvancements(): Promise<Advancement[]> {
  const apiRequest = new ApiRequest();
  apiRequest.setMethod(RequestMethod.GET);
  apiRequest.setUrl(URL);

  const response: any = await apiRequest.send();

  return response.data.map((advancement: any) => ({
    id: advancement["id"],
    name: advancement["name"],
    cost: advancement["cost"]
  }));
}
